// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tan1","signatureBlock":"Footer_signatureBlock__1x_il","signature":"Footer_signature__2daHz"};